const StoryFrameworkPlayerEvent = {};
export default StoryFrameworkPlayerEvent;

/**
 * The StoryFrameworkPlayerEvent.STORY_START constant defines the value of the 
 * <code>type</code> property of the event object 
 * for a <code>STORY_START</code> event.
 *
 * <p>The properties of the StoryPlayerEvent have the following values:</p>
 * <table class=innertable>
 * <tr><th>Property</th><th>Value</th></tr>
 * <tr><td>storyArc</td><td>null</td></tr>
 * <tr><td>storyNode</td><td>null</td></tr>
 * </table>
 *
 * @eventType STORY_START
 */
StoryFrameworkPlayerEvent.STORY_START = "STORY_START";
/**
 * The StoryFrameworkPlayerEvent.STORY_END constant defines the value of the 
 * <code>type</code> property of the event object 
 * for a <code>STORY_END</code> event.
 *
 * <p>The properties of the StoryPlayerEvent have the following values:</p>
 * <table class=innertable>
 * <tr><th>Property</th><th>Value</th></tr>
 * <tr><td>storyArc</td><td>null</td></tr>
 * <tr><td>storyNode</td><td>null</td></tr>
 * </table>
 *
 * @eventType STORY_END
 */
StoryFrameworkPlayerEvent.STORY_END = "STORY_END";
/**
 * The StoryFrameworkPlayerEvent.STORY_NODE_UNLOCKED constant defines the value of the 
 * <code>type</code> property of the event object 
 * for a <code>STORY_END</code> event.
 *
 * <p>The properties of the StoryPlayerEvent have the following values:</p>
 * <table class=innertable>
 * <tr><th>Property</th><th>Value</th></tr>
 * <tr><td>storyArc</td><td>The StoryArc the unlocked StoryNode belongs to</td></tr>
 * <tr><td>storyNode</td><td>The unlocked StoryNode</td></tr>
 * </table>
 *
 * @eventType STORY_NODE_UNLOCKED
 */
StoryFrameworkPlayerEvent.STORY_NODE_UNLOCKED = "STORY_NODE_UNLOCKED";
/**
 * The StoryFrameworkPlayerEvent.STORY_NODE_AVAILABLE constant defines the value of the 
 * <code>type</code> property of the event object 
 * for a <code>STORY_END</code> event.
 *
 * <p>The properties of the StoryPlayerEvent have the following values:</p>
 * <table class=innertable>
 * <tr><th>Property</th><th>Value</th></tr>
 * <tr><td>storyArc</td><td>The StoryArc the StoryNode that became available belongs to</td></tr>
 * <tr><td>storyNode</td><td>The StoryNode that became available</td></tr>
 * </table>
 *
 * @eventType STORY_NODE_AVAILABLE
 */
StoryFrameworkPlayerEvent.STORY_NODE_AVAILABLE = "STORY_NODE_AVAILABLE";
/**
 * The StoryFrameworkPlayerEvent.STORY_END constant defines the value of the 
 * <code>type</code> property of the event object 
 * for a <code>STORY_NODE_UNAVAILABLE</code> event.
 *
 * <p>The properties of the StoryPlayerEvent have the following values:</p>
 * <table class=innertable>
 * <tr><th>Property</th><th>Value</th></tr>
 * <tr><td>storyArc</td><td>The StoryArc the StoryNode that became unavailable belongs to</td></tr>
 * <tr><td>storyNode</td><td>The StoryNode that became unavailable</td></tr>
 * </table>
 *
 * @eventType STORY_NODE_UNAVAILABLE
 */
StoryFrameworkPlayerEvent.STORY_NODE_UNAVAILABLE = "STORY_NODE_UNAVAILABLE";
/**
 * The StoryFrameworkPlayerEvent.STORY_END constant defines the value of the 
 * <code>type</code> property of the event object 
 * for a <code>STORY_NODE_COMPLETED</code> event.
 *
 * <p>The properties of the StoryPlayerEvent have the following values:</p>
 * <table class=innertable>
 * <tr><th>Property</th><th>Value</th></tr>
 * <tr><td>storyArc</td><td>The StoryArc the StoryNode that is completed belongs to</td></tr>
 * <tr><td>storyNode</td><td>The StoryNode is completed available</td></tr>
 * </table>
 *
 * @eventType STORY_NODE_COMPLETED
 */
StoryFrameworkPlayerEvent.STORY_NODE_COMPLETED = "STORY_NODE_COMPLETED";
/**
 * The StoryFrameworkPlayerEvent.STORY_ARC_UNLOCKED constant defines the value of the 
 * <code>type</code> property of the event object 
 * for a <code>STORY_ARC_UNLOCKED</code> event.
 *
 * <p>The properties of the StoryPlayerEvent have the following values:</p>
 * <table class=innertable>
 * <tr><th>Property</th><th>Value</th></tr>
 * <tr><td>storyArc</td><td>The StoryArc that became unlocked</td></tr>
 * <tr><td>storyNode</td><td>null</td></tr>
 * </table>
 *
 * @eventType STORY_ARC_UNLOCKED
 */
StoryFrameworkPlayerEvent.STORY_ARC_UNLOCKED = "STORY_ARC_UNLOCKED";
/**
 * The StoryFrameworkPlayerEvent.STORY_ARC_AVAILABLE constant defines the value of the 
 * <code>type</code> property of the event object 
 * for a <code>STORY_ARC_AVAILABLE</code> event.
 *
 * <p>The properties of the StoryPlayerEvent have the following values:</p>
 * <table class=innertable>
 * <tr><th>Property</th><th>Value</th></tr>
 * <tr><td>storyArc</td><td>The StoryArc that became available</td></tr>
 * <tr><td>storyNode</td><td>null</td></tr>
 * </table>
 *
 * @eventType STORY_ARC_AVAILABLE
 */
StoryFrameworkPlayerEvent.STORY_ARC_AVAILABLE = "STORY_ARC_AVAILABLE";
/**
 * The StoryFrameworkPlayerEvent.STORY_ARC_UNAVAILABLE constant defines the value of the 
 * <code>type</code> property of the event object 
 * for a <code>STORY_ARC_UNAVAILABLE</code> event.
 *
 * <p>The properties of the StoryPlayerEvent have the following values:</p>
 * <table class=innertable>
 * <tr><th>Property</th><th>Value</th></tr>
 * <tr><td>storyArc</td><td>The StoryArc that became unavailable</td></tr>
 * <tr><td>storyNode</td><td>null</td></tr>
 * </table>
 *
 * @eventType STORY_ARC_UNAVAILABLE
 */
StoryFrameworkPlayerEvent.STORY_ARC_UNAVAILABLE = "STORY_ARC_UNAVAILABLE";
/**
 * The StoryFrameworkPlayerEvent.STORY_ARC_COMPLETED constant defines the value of the 
 * <code>type</code> property of the event object 
 * for a <code>STORY_ARC_COMPLETED</code> event.
 *
 * <p>The properties of the StoryPlayerEvent have the following values:</p>
 * <table class=innertable>
 * <tr><th>Property</th><th>Value</th></tr>
 * <tr><td>storyArc</td><td>The StoryArc that became completed</td></tr>
 * <tr><td>storyNode</td><td>null</td></tr>
 * </table>
 *
 * @eventType STORY_ARC_COMPLETED
 */
StoryFrameworkPlayerEvent.STORY_ARC_COMPLETED = "STORY_ARC_COMPLETED";

